import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Svg from 'components/Svg';

function handleBackToHomeClick() {
  window.location.href = '/';
}

function ApplicationError() {
  return (
    <Container maxWidth="sm" className="application-error-container">
      <Grid container justifyContent="center" alignItems="center">
        <Grid item textAlign="left">
          <Typography variant="h2" textAlign="left" mb={0}>
            Is Mercury in retrograde?
          </Typography>

          <Box>
            <Svg width="300px" height="300px" name="error-500" />
          </Box>

          <Box mb={2}>We apologize. An error has occurred.</Box>

          <Box mt={5}>
            <Button
              type="button"
              variant="primary"
              onClick={handleBackToHomeClick}>
              Back to home
            </Button>
          </Box>

          <Box my={5}>
            If you have any questions, please contact our&#160;
            <span className="nowrap">
              <a href="/help/support">Customer Support</a> team.
            </span>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}

export default ApplicationError;
